'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterWrapper = exports.ToasterContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  border: 1px solid blue;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 8px 0;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  border: 1px solid blue;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 8px 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid red;\n  display: inline-block;\n  margin: 8px 16px;\n  /* position: absolute;\n  bottom: 0; */\n'], ['\n  border: 1px solid red;\n  display: inline-block;\n  margin: 8px 16px;\n  /* position: absolute;\n  bottom: 0; */\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToasterContainer = exports.ToasterContainer = _styledComponents2.default.div(_templateObject);

var ToasterWrapper = exports.ToasterWrapper = _styledComponents2.default.div(_templateObject2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/konsys-ui/dist/lib/toaster/styled.js
// module id = 703
// module chunks = 0